export const buildReactivateProductAction = ({
  canReactivate,
  onReactivate,
  reactivatingProductId,
  disabled,
}) => ({
  label: "Reactivate",
  icon: "arrows-rotate",
  iconStyle: "solid",
  hidden: (row) => row.product?.active !== false || !canReactivate,
  // Also disabled while this row's product is mid-reactivation, so the action
  // can't be re-triggered before onSuccess flips it active and hides it.
  disabled: (row) =>
    (disabled ? disabled(row) : false) ||
    (reactivatingProductId != null &&
      row.product?.id === reactivatingProductId),
  onClickSingle: (row) => onReactivate(row.product.id),
  confirm: {
    title: "Reactivate item",
    message: (row) =>
      `Reactivate ${row.product?.name}? This makes it available across your catalog again.`,
    confirmLabel: "Reactivate",
  },
})
